module.exports = __webpack_public_path__ + "img/adani.ce7dadb6.webp";